module.exports = __webpack_public_path__ + "img/Pizza Rock.be6db129.svg";